import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  stopSubmit,
  setSubmitFailed,
  formValueSelector,
} from "redux-form";
import _ from "lodash";
import moment from "moment";
import Button from "react-bootstrap-button-loader";
import {
  Modal,
  Popover,
  OverlayTrigger,
  PopoverHeader,
  PopoverBody,
} from "react-bootstrap";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import TimePicker from "react-bootstrap-time-picker";
import { timeFromInt } from "time-number";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  addTicket,
  updateTicket,
  openTicketModal,
  editTicket,
  ticketnameExist,
  checkTicketDaschoardStatus,
} from "TicketAction";
import { openUserCategoryModal } from "DashboardUserAction";
import {
  COMMON_FAIL_MESSAGE,
  EVENTIFY_FEE,
  STRIPE_FEE,
  STRIPE_FEE_EXTRA,
  DATE_FORMAT,
  DATE_FORMAT_WITH_TIME,
  DEVELOPMENT_TYPE,
  maxLengthObjectFc,
  DISPLAY_LOCAL_DATE_FORMAT,
  checkDateFormatYMD,
} from "Constants";
import { isEmpty } from "BaseFunctions";
import LocaleStrings from "Languages";
var MAXLENOBJ = {};
class AddTicket extends Component {
  constructor(props) {
    super(props);

    this.state = { loading: false, dateError: {} };

    this.closeModal = this.closeModal.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history);
  }

  closeModal() {
    this.props.reset();
    this.props.openTicketModal({ showModal: false });
  }

  onManageUserCategory = () => {
    this.props.openTicketModal({ showModal: false });
    this.props.openUserCategoryModal(true);
  };

  onSubmitForm(data) {
    let { showModal, editMode, userCategoryList } = this.props;
    let values = { ...data };
    // console.log("submitted values :- ", values);
    // debugger;

    if (userCategoryList.data.length == 0) {
      this.props.dispatch(stopSubmit("TicketForm"));
      this.props.showError(
        LocaleStrings.user_manage_user_category_text_error_any_form_sbumit_category_not_ctreated
      );

      return;
    }

    // Ticket start date and end date only applicable to eventify tickets, not for koachify plans
    if (DEVELOPMENT_TYPE === "eventify") {
      if (typeof values.startdate === "string") {
        if (!checkDateFormatYMD(values.startdate)) {
          var startdate = moment(
            values.startdate,
            DISPLAY_LOCAL_DATE_FORMAT
          ).format(DATE_FORMAT);
        } else {
          var startdate = moment(values.startdate).format(DATE_FORMAT);
        }
      } else {
        var startdate = moment(values.startdate).format(DATE_FORMAT);
      }
      if (typeof values.enddate === "string") {
        if (!checkDateFormatYMD(values.enddate)) {
          var enddate = moment(
            values.enddate,
            DISPLAY_LOCAL_DATE_FORMAT
          ).format(DATE_FORMAT);
        } else {
          var enddate = moment(values.enddate).format(DATE_FORMAT);
        }
      } else {
        var enddate = moment(values.enddate).format(DATE_FORMAT);
      }
      // console.log("startdate", startdate);
      // console.log("enddate", enddate);

      var starttime = values.starttime ? values.starttime : "0:00";
      var endtime = values.endtime ? values.endtime : "0:05";
      var starttimeIsFormatted = _.split(starttime, ":").length > 1;
      var endtimeIsFormatted = _.split(endtime, ":").length > 1;
      if (!starttimeIsFormatted) {
        starttime = timeFromInt(parseInt(starttime));
        starttime =
          _.split(starttime, ":").length === 2 ? `${starttime}:00` : starttime;
      }
      if (!endtimeIsFormatted) {
        endtime = timeFromInt(parseInt(endtime));
        endtime =
          _.split(endtime, ":").length === 2 ? `${endtime}:00` : endtime;
      }
      var salestartdate = `${startdate} ${starttime}`;
      var saleenddate = `${enddate} ${endtime}`;
      // console.log("salestartdate", salestartdate);
      // console.log("saleenddate", saleenddate);

      if (!moment(startdate).isValid()) {
        let errorMessage =
          LocaleStrings.tickets_ticket_form_validation_invalid_start_date;
        this.props.showError(errorMessage);
        return;
      }
      if (!moment(enddate).isValid()) {
        let errorMessage =
          LocaleStrings.tickets_ticket_form_validation_invalid_end_date;
        this.props.showError(errorMessage);
        return;
      }

      values.salestartdate = salestartdate;
      values.saleenddate = saleenddate;
    }

    if (DEVELOPMENT_TYPE === "koachify") {
      values.type = "plan";
    }

    if (values.tickettype == "free") {
      values.price = 0;
      values.currency = "";
      values.feesetting = "absorb";
      values.isofflinepayment = 0;
    }

    if (values.currency == "ZAR") {
      values.feesetting = "absorb";
    }

    // Ticket associated with user category type

    // Below code is commented by vinay on 06-10-2020
    // let userCat = values.usercategory;
    // var res = '';
    // if(userCat) {
    //   if(userCat != '' && Array.isArray(userCat) && userCat.length > 0) {
    //     res = userCat.join(',');
    //   }
    //   else if(userCat != '' && !Array.isArray(userCat)) {
    //     res = userCat;
    //   }
    //   else {
    //     var attendee = _.filter(this.props.userCategoryList.data, obj => {return obj.type == 'attendee'});
    //     res = attendee[0].id;
    //   }
    // }
    // else {
    //   var attendee = _.filter(this.props.userCategoryList.data, obj => {return obj.type == 'attendee'});
    //   res = attendee[0].id;
    // }
    // values.usercategory = res;

    let res = null;
    if (showModal && showModal.category) {
      var cate = _.filter(this.props.userCategoryList.data, (obj) => {
        return obj.type == showModal.category;
      });
      if (cate.length > 0) {
        res = cate[0].id;
      } else {
        var attendee = _.filter(this.props.userCategoryList.data, (obj) => {
          return obj.type == "attendee";
        });
        res = attendee[0].id;
      }
    } else {
      var attendee = _.filter(this.props.userCategoryList.data, (obj) => {
        return obj.type == "attendee";
      });
      res = attendee[0].id;
    }
    values.usercategory = showModal.genre === "addon" ? null : res;
    values.formid = showModal.genre === "addon" ? null : data.formid;

    // --- Tracking pixel codes
    if (
      !_.isEmpty(values.ticket_tracking_header) ||
      !_.isEmpty(values.ticket_tracking_footer)
    ) {
      let local_trackingPixel = {
        header: values.ticket_tracking_header,
        footer: values.ticket_tracking_footer,
      };

      values.trackingpixel = JSON.stringify(local_trackingPixel);
    }

    delete values["countryofsale"];
    delete values["createdby"];
    delete values["createdon"];
    delete values["gatewayfee"];
    delete values["isaccessall"];
    delete values["tickecode"];
    delete values["timezone"];
    delete values["ticketurl"];
    delete values["updatedby"];
    delete values["updatedon"];
    delete values["startdate"];
    delete values["starttime"];
    delete values["enddate"];
    delete values["endtime"];
    delete values["ticket_tracking_header"];
    delete values["ticket_tracking_footer"];
    delete values["event_forms_by_formid"];
    delete values["orderdetails_by_ticketid"];

    // console.log("final values :- ", values);

    this.setState({ loading: true });
    if (editMode) {
      delete values["usercategory"];
      if (values.quantity > values.totalsoldtickets) {
        delete values["totalsoldtickets"];

        if (values.formid != this.props.oldFormAssociated) {
          confirmAlert({
            title: LocaleStrings.tickets_ticket_title_update_ticket,
            message:
              LocaleStrings.tickets_ticket_text_sure_want_to_update_with_form_change,
            confirmLabel: LocaleStrings.button_ok,
            cancelLabel: LocaleStrings.button_cancel,
            buttons: [
              {
                label: LocaleStrings.button_ok,
                onClick: () => {
                  this.props.updateTicket(
                    values,
                    this.props.session,
                    (response) => {
                      if (response.success === 0) {
                        this.setState({ loading: false });
                        this.props.showError(COMMON_FAIL_MESSAGE);
                      } else {
                        this.setState({ loading: false });
                        this.props.checkTicketDaschoardStatus(
                          this.props.session
                        );
                        this.props.showSuccess(
                          LocaleStrings.tickets_ticket_form_ticket_updated_success
                        );
                        this.closeModal();
                        this.props.finishOperationsCallback();
                      }
                    }
                  );
                },
              },
              {
                label: LocaleStrings.button_cancel,
                onClick: () => {
                  this.setState({ loading: false });
                },
              },
            ],
          });
        } else {
          this.props.updateTicket(values, this.props.session, (response) => {
            if (response.success === 0) {
              this.setState({ loading: false });
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else {
              this.setState({ loading: false });
              this.props.checkTicketDaschoardStatus(this.props.session);
              this.props.showSuccess(
                LocaleStrings.tickets_ticket_form_ticket_updated_success
              );
              this.closeModal();
              this.props.finishOperationsCallback();
            }
          });
        }
      } else {
        this.setState({ loading: false });
        var errorMessage =
          LocaleStrings.tickets_ticket_form_validation_quantity_should_be_greater_than_sold_quantity;
        let dateError = { quantityerror: errorMessage };
        this.setState({ dateError: dateError });
        this.props.dispatch(setSubmitFailed("TicketForm", "quantity"));
        this.props.dispatch(stopSubmit("TicketForm", new Error(errorMessage)));
        setTimeout(() => {
          this.setState({ dateError: {} });
        }, 2000);
      }
    } else {
      this.props.ticketnameExist(
        this.props.session,
        values.ticketname,
        (ticketresponse) => {
          if (ticketresponse.success) {
            this.props.addTicket(this.props.session, values, (response) => {
              if (response.success === 0) {
                this.setState({ loading: false });
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                this.setState({ loading: false });
                this.props.checkTicketDaschoardStatus(this.props.session);
                this.props.showSuccess(
                  LocaleStrings.tickets_ticket_form_ticket_added_success
                );
                this.closeModal();
                this.props.finishOperationsCallback();
              }
            });
          } else {
            this.setState({ loading: false });
            var errorMessage =
              LocaleStrings.tickets_ticket_form_validation_ticket_allready_exists;
            let dateError = { ticketnameerror: errorMessage };
            this.props.showError(errorMessage);
            this.setState({ dateError: dateError });
            this.props.dispatch(setSubmitFailed("TicketForm", "ticketname"));
            this.props.dispatch(
              stopSubmit("TicketForm", new Error(errorMessage))
            );

            setTimeout(() => {
              this.setState({ dateError: {} });
            }, 2000);
          }
        }
      );
    }
  }

  render() {
    let {
      handleSubmit,
      pristine,
      submitting,
      invalid,
      initialValues,
      editMode,
      showModal,
      settingInfo,
      stripeCurrency,
    } = this.props;
    let { dateError } = this.state;
    // console.log("showModal :- ", showModal);

    return (
      <div>
        <Modal
          className="modal-container"
          show={showModal.showModal === true ? true : false}
          animation={true}
          keyboard={false}
          backdrop="static"
          dialogClassName="ticket-new-modal"
        >
          <form onSubmit={handleSubmit(this.onSubmitForm)}>
            <Modal.Header>
              <div className="import-modal-title">
                {editMode
                  ? LocaleStrings.tickets_ticket_title_edit_ticket
                  : LocaleStrings.tickets_ticket_title_add_ticket}
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.closeModal()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body className="scrollable-modal">
              <div>
                {DEVELOPMENT_TYPE === "koachify" ? (
                  <AddPlanForm
                    editMode={editMode}
                    dateError={dateError}
                    initialValues={initialValues}
                    currencyList={stripeCurrency}
                    tax={
                      settingInfo &&
                      settingInfo.resource &&
                      settingInfo.resource.length > 0 &&
                      settingInfo.resource[0].tax
                        ? settingInfo.resource[0].tax
                        : 0
                    }
                    taxname={
                      settingInfo &&
                      settingInfo.resource &&
                      settingInfo.resource.length > 0 &&
                      settingInfo.resource[0].taxname
                        ? settingInfo.resource[0].taxname
                        : ""
                    }
                    {...this.props}
                    onManageCategory={this.onManageUserCategory}
                  />
                ) : (
                  <AddTicketForm
                    editMode={editMode}
                    dateError={dateError}
                    initialValues={initialValues}
                    currencyList={stripeCurrency}
                    tax={
                      settingInfo &&
                      settingInfo.resource &&
                      settingInfo.resource.length > 0 &&
                      settingInfo.resource[0].tax
                        ? settingInfo.resource[0].tax
                        : 0
                    }
                    taxname={
                      settingInfo &&
                      settingInfo.resource &&
                      settingInfo.resource.length > 0 &&
                      settingInfo.resource[0].taxname
                        ? settingInfo.resource[0].taxname
                        : ""
                    }
                    {...this.props}
                    onManageCategory={this.onManageUserCategory}
                  />
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                bsStyle=""
                className="btn btn-custom-white"
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
              <Button
                className="btn btn-custom-blue ml-10"
                bsStyle=""
                loading={this.state.loading}
                disabled={pristine || invalid || submitting}
                type="submit"
              >
                {LocaleStrings.button_save}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

const selector = formValueSelector("TicketForm");

function mapStateToProps(state) {
  let oldFormAssociated = null;
  let currency = "USD";
  let allPaidTicket = _.filter(state.allTicketList.resource, (curr) => {
    return curr.tickettype == "paid";
  });

  if (allPaidTicket.length > 0) {
    currency = allPaidTicket[0].currency;
  }

  let stripeAcceptedCurrencies = [
    "AUD",
    "BRL",
    "CAD",
    "CZK",
    "CHF",
    "DKK",
    "DZD",
    "EUR",
    "GBP",
    "HKD",
    "HUF",
    "ILS",
    "JPY",
    "MYR",
    "MXN",
    "NZD",
    "NOK",
    "PHP",
    "PLN",
    "RUB",
    "SGD",
    "SEK",
    "TWD",
    "THB",
    "USD",
    "ZAR",
  ];
  // if(state.SettingData && state.SettingData.resource && state.SettingData.resource.length > 0 && state.SettingData.resource[0].paymentgatewaytype === "payfast") {
  //   stripeAcceptedCurrencies = ['ZAR'];
  //   currency = 'ZAR';
  // }

  let stripeCurrency = [];
  _.map(stripeAcceptedCurrencies, (cur) => {
    var matched = _.filter(state.ticketCurrency, (match) => {
      return cur == match.code;
    });
    stripeCurrency.push(matched[0]);
  });

  var toEdit = !isEmpty(state.EditTicket);
  var initVals = {};
  if (toEdit) {
    initVals = state.EditTicket;
    if (state.EditTicket.tax && state.EditTicket.tax > 0) {
      initVals.tax = state.EditTicket.tax;
    } else {
      initVals.tax = "";
    }

    if (!_.isEmpty(initVals?.trackingpixel)) {
      let local_trackingpixel = JSON.parse(initVals.trackingpixel);

      initVals.ticket_tracking_header = local_trackingpixel.header;
      initVals.ticket_tracking_footer = local_trackingpixel.footer;
    }

    initVals.startdate = moment(initVals.startdate).format(DATE_FORMAT);
    initVals.enddate = moment(initVals.enddate).format(DATE_FORMAT);

    oldFormAssociated = initVals.formid;
  } else {
    var formid = null;
    if (
      state.showTicketModal &&
      state.showTicketModal.category &&
      (state.showTicketModal.category === "attendee" ||
        state.showTicketModal.category === "speaker")
    ) {
      formid =
        state.totalFormBuildeList &&
        state.totalFormBuildeList.resource &&
        state.totalFormBuildeList.resource.attendee.length > 0
          ? state.totalFormBuildeList.resource.attendee[0].formid
          : null;
    } else if (
      state.showTicketModal &&
      state.showTicketModal.category &&
      state.showTicketModal.category === "exhibitor"
    ) {
      formid =
        state.totalFormBuildeList &&
        state.totalFormBuildeList.resource &&
        state.totalFormBuildeList.resource.exhibitor.length > 0
          ? state.totalFormBuildeList.resource.exhibitor[0].formid
          : null;
    } else if (
      state.showTicketModal &&
      state.showTicketModal.category &&
      state.showTicketModal.category === "sponsor"
    ) {
      formid =
        state.totalFormBuildeList &&
        state.totalFormBuildeList.resource &&
        state.totalFormBuildeList.resource.sponsor.length > 0
          ? state.totalFormBuildeList.resource.sponsor[0].formid
          : null;
    } else {
      formid =
        state.totalFormBuildeList &&
        state.totalFormBuildeList.resource &&
        state.totalFormBuildeList.resource.attendee.length > 0
          ? state.totalFormBuildeList.resource.attendee[0].formid
          : null;
    }

    initVals = {
      starttime: "0:00",
      endtime: "0:05",
      currency: currency,
      tickettype: "paid",
      feesetting: "absorb",
      formid: state.showTicketModal.genre === "addon" ? null : formid,
      type: state.showTicketModal.genre,
      isofflinepayment: 0,
    };
    if (
      state.showTicketModal &&
      state.showTicketModal.category &&
      (state.showTicketModal.category === "exhibitor" ||
        state.showTicketModal.category === "sponsor")
    ) {
      initVals.minbooking = 1;
      initVals.maxbooking = 1;
    }

    if (DEVELOPMENT_TYPE === "koachify") {
      initVals = {
        currency: currency,
        tickettype: "paid",
        feesetting: "absorb",
        formid: formid,
        isofflinepayment: 0,
      };
      initVals.minbooking = 1;
      initVals.maxbooking = 1;
      initVals.quantity = 100000;
    } else {
      initVals.ticket_tracking_header = "";
      initVals.ticket_tracking_footer = "";
    }
  }

  var totalFormBuildeList = [];
  if (
    state.showTicketModal &&
    state.showTicketModal.category &&
    (state.showTicketModal.category === "attendee" ||
      state.showTicketModal.category === "speaker")
  ) {
    totalFormBuildeList =
      state.totalFormBuildeList && state.totalFormBuildeList.resource
        ? state.totalFormBuildeList.resource.attendee
        : [];
  } else if (
    state.showTicketModal &&
    state.showTicketModal.category &&
    state.showTicketModal.category === "exhibitor"
  ) {
    totalFormBuildeList =
      state.totalFormBuildeList && state.totalFormBuildeList.resource
        ? state.totalFormBuildeList.resource.exhibitor
        : [];
  } else if (
    state.showTicketModal &&
    state.showTicketModal.category &&
    state.showTicketModal.category === "sponsor"
  ) {
    totalFormBuildeList =
      state.totalFormBuildeList && state.totalFormBuildeList.resource
        ? state.totalFormBuildeList.resource.sponsor
        : [];
  } else {
    totalFormBuildeList =
      state.totalFormBuildeList && state.totalFormBuildeList.resource
        ? state.totalFormBuildeList.resource.attendee
        : [];
  }

  return {
    session: state.session,
    showModal: state.showTicketModal,
    ticketCurrency: state.ticketCurrency,
    stripeCurrency: stripeCurrency,
    initialValues: initVals,
    editMode: !_.isEmpty(state.EditTicket),
    oldFormAssociated,
    totalFormBuildeList,
    stripeCurrencyDetailsList: state.stripeCurrencyDetailsList,
    userCategoryList: state.userCategoryList,
    settingInfo: state.SettingData,
    ticketDashboard: state.ticketDashboard.data,
    allTicketList: state.allTicketList.resource,

    owntaxname: selector(state, "taxname"),
    owntaxrate: selector(state, "tax"),
    feesetting: selector(state, "feesetting"),
    currency: selector(state, "currency"),
    tickettype: selector(state, "tickettype"),
    price: selector(state, "price"),
  };
}

function validate(values, ownProps) {
  var errors = {};
  var ticketname = values["ticketname"];
  var quantity = parseInt(values["quantity"]);
  var minbooking = parseInt(values["minbooking"]);
  var maxbooking = parseInt(values["maxbooking"]);
  var price = values["price"];
  var ticketdesc = values["ticketdesc"];
  var tickettype = values["tickettype"];
  var currency = values["currency"];
  var status = values["status"];
  var formid = values["formid"];
  var childticketid = values["childticketid"];
  var noofchildtickets = values["noofchildtickets"];
  var startdate = values["startdate"];
  var enddate = values["enddate"];
  var starttime = values["starttime"];
  var endtime = values["endtime"];
  var plandays = values["plandays"];
  var taxname = values["taxname"];
  var tax = values["tax"];
  // console.log("validate values :- ", values);

  if (!ticketname || ticketname.trim() === "") {
    errors["ticketname"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (!quantity) {
    errors["quantity"] = LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (!minbooking) {
    errors["minbooking"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (!maxbooking) {
    errors["maxbooking"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (minbooking > quantity) {
    errors["minbooking"] =
      LocaleStrings.tickets_ticket_form_validation_min_booking_should_less_than_quantity;
  }
  if (maxbooking > quantity) {
    errors["maxbooking"] =
      LocaleStrings.tickets_ticket_form_validation_max_booking_should_less_than_quantity;
  }
  if (maxbooking < minbooking) {
    errors["maxbooking"] =
      LocaleStrings.tickets_ticket_form_validation_max_booking_always_greater_equal_min_booking;
  }
  if (!tickettype) {
    errors["tickettype"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (!price && tickettype == "paid") {
    errors["price"] = LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (price && tickettype == "paid" && price < 2) {
    errors["price"] =
      LocaleStrings.tickets_ticket_form_validation_ticket_price_should_greater_than_1;
  }
  if (!currency && tickettype == "paid") {
    errors["currency"] = LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (
    tickettype == "paid" &&
    currency &&
    currency == "ZAR" &&
    ownProps.ticketDashboard &&
    ownProps.ticketDashboard.paymentgateway == true &&
    ownProps.ticketDashboard.selectedpaymentgateway == "stripe"
  ) {
    errors["currency"] =
      LocaleStrings.tickets_ticket_form_validation_stripe_support_currency;
  }
  if (
    tickettype == "paid" &&
    currency &&
    currency != "ZAR" &&
    ownProps.ticketDashboard &&
    ownProps.ticketDashboard.paymentgateway == true &&
    ownProps.ticketDashboard.selectedpaymentgateway == "payfast"
  ) {
    errors["currency"] =
      LocaleStrings.tickets_ticket_form_validation_payfast_support_currency;
  }
  if (tax && !parseInt(tax, 10)) {
    errors["tax"] =
      LocaleStrings.tickets_setting_form_validation_only_positive_number;
  }
  if (tax && tax > 30) {
    errors["tax"] =
      LocaleStrings.tickets_setting_form_validation_tax_should_be_less_equal_30;
  }
  if (tax && tax < 1) {
    errors["tax"] =
      LocaleStrings.tickets_setting_form_validation_tax_should_not_be_less_equal_1;
  }
  if (taxname && MAXLENOBJ) {
    if (taxname.length > MAXLENOBJ.taxname) {
      errors["taxname"] = LocaleStrings.max_characters_left + MAXLENOBJ.taxname;
    }
  }
  if (DEVELOPMENT_TYPE === "koachify") {
    if (!plandays) {
      errors["plandays"] =
        LocaleStrings.tickets_ticket_form_validation_required;
    }
    if (plandays && plandays < 1) {
      errors["plandays"] =
        LocaleStrings.tickets_ticket_form_validation_ticket_planday_should_greater_than_1;
    }
  }
  if (!ticketdesc || ticketdesc.trim() === "") {
    errors["ticketdesc"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (ticketdesc && ticketdesc.length > 50) {
    errors["ticketdesc"] =
      LocaleStrings.tickets_ticket_form_validation_ticket_description_only_50_char;
  }
  if (!status) {
    errors["status"] = LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (
    status &&
    status != "disabled" &&
    currency &&
    currency == "ZAR" &&
    ownProps.ticketDashboard &&
    ownProps.ticketDashboard.paymentgateway == true &&
    ownProps.ticketDashboard.selectedpaymentgateway == "stripe"
  ) {
    errors["status"] =
      LocaleStrings.tickets_ticket_form_validation_not_enable_zar_tickets_stripe;
  }
  if (
    status &&
    status != "disabled" &&
    currency &&
    currency != "ZAR" &&
    ownProps.ticketDashboard &&
    ownProps.ticketDashboard.paymentgateway == true &&
    ownProps.ticketDashboard.selectedpaymentgateway == "payfast"
  ) {
    errors["status"] =
      LocaleStrings.tickets_ticket_form_validation_not_enable_othetcurrency_tickets_payfast;
  }
  if (
    status &&
    status == "disabled" &&
    ownProps.initialValues.id &&
    ownProps.initialValues.id != ""
  ) {
    var tid = ownProps.initialValues.id;
    var matchTickets = _.filter(ownProps.allTicketList, (obj) => {
      return obj.childticketid == tid && obj.status != "disabled";
    });
    if (matchTickets.length > 0) {
      var result = _.map(matchTickets, (item) => item.ticketname);
      errors["statuserror"] =
        LocaleStrings.tickets_ticket_form_validation_not_disable_associated_ticket +
        ` (i.e. ${result.join(", ")})`;
    }
  }
  if (!formid && ownProps.showModal.genre !== "addon") {
    errors["formid"] = LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (
    !childticketid &&
    (ownProps.showModal.category == "exhibitor" ||
      ownProps.showModal.category == "sponsor")
  ) {
    errors["childticketid"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (
    childticketid &&
    enddate &&
    endtime &&
    (ownProps.showModal.category == "exhibitor" ||
      ownProps.showModal.category == "sponsor")
  ) {
    var matchChildTicket = _.filter(ownProps.allTicketList, (obj) => {
      return obj.id == childticketid;
    });
    if (matchChildTicket.length > 0) {
      var chEDate = matchChildTicket[0].saleenddate;

      if (typeof enddate === "string") {
        if (!checkDateFormatYMD(enddate)) {
          var edate = moment(enddate, `${DISPLAY_LOCAL_DATE_FORMAT}`).format(
            DATE_FORMAT
          );
        } else {
          var edate = moment(enddate).format(DATE_FORMAT);
        }
      } else {
        var edate = moment(enddate).format(DATE_FORMAT);
      }
      var etime = endtime;
      var endtimeIsFormatted = _.split(endtime, ":").length > 1;
      if (!endtimeIsFormatted) {
        etime = timeFromInt(parseInt(endtime));
        etime = _.split(etime, ":").length === 2 ? `${etime}:00` : etime;
      }
      var et = `${edate} ${etime}`;
      if (moment(chEDate).isBefore(et)) {
        errors["dateerror"] =
          LocaleStrings.tickets_ticket_form_validation_end_datetime_cannot_greater_than_child_end_datetime +
          ` (i.e. ${moment(chEDate).format("YYYY-MM-DD h:mm a")})`;
      }
    }
  }
  if (
    !noofchildtickets &&
    (ownProps.showModal.category == "exhibitor" ||
      ownProps.showModal.category == "sponsor")
  ) {
    errors["noofchildtickets"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  } else if (noofchildtickets && noofchildtickets < 1) {
    errors["noofchildtickets"] =
      LocaleStrings.tickets_ticket_form_validation_no_attendee_ticket_min_1;
  }

  if (DEVELOPMENT_TYPE === "eventify") {
    if (!startdate) {
      errors["startdate"] =
        LocaleStrings.tickets_ticket_form_validation_required;
    }
    if (!enddate) {
      errors["enddate"] = LocaleStrings.tickets_ticket_form_validation_required;
    }
    if (!starttime) {
      errors["starttime"] =
        LocaleStrings.tickets_ticket_form_validation_required;
    }
    if (!endtime) {
      errors["endtime"] = LocaleStrings.tickets_ticket_form_validation_required;
    }

    if (startdate && enddate && starttime && endtime) {
      if (typeof startdate === "string") {
        if (!checkDateFormatYMD(startdate)) {
          startdate = moment(startdate, `${DISPLAY_LOCAL_DATE_FORMAT}`).format(
            DATE_FORMAT
          );
        } else {
          startdate = moment(startdate).format(DATE_FORMAT);
        }
      } else {
        startdate = moment(startdate).format(DATE_FORMAT);
      }
      if (typeof enddate === "string") {
        if (!checkDateFormatYMD(enddate)) {
          enddate = moment(enddate, `${DISPLAY_LOCAL_DATE_FORMAT}`).format(
            DATE_FORMAT
          );
        } else {
          enddate = moment(enddate).format(DATE_FORMAT);
        }
      } else {
        enddate = moment(enddate).format(DATE_FORMAT);
      }

      var starttimeIsFormatted = _.split(starttime, ":").length > 1;
      var endtimeIsFormatted = _.split(endtime, ":").length > 1;
      if (!starttimeIsFormatted) {
        starttime = timeFromInt(parseInt(starttime));
        starttime =
          _.split(starttime, ":").length === 2 ? `${starttime}:00` : starttime;
      }
      if (!endtimeIsFormatted) {
        endtime = timeFromInt(parseInt(endtime));
        endtime =
          _.split(endtime, ":").length === 2 ? `${endtime}:00` : endtime;
      }
      var salestartdate = `${startdate} ${starttime}`;
      var saleenddate = `${enddate} ${endtime}`;

      if (saleenddate <= salestartdate) {
        errors["dateerror"] =
          LocaleStrings.tickets_ticket_form_validation_end_date_should_greater_equal_than_start_date;
      }
    }

    if (values["ticketname"] && MAXLENOBJ) {
      if (values["ticketname"].length > MAXLENOBJ.ticketname) {
        errors["ticketname"] =
          LocaleStrings.max_characters_left + MAXLENOBJ.ticketname;
      }
    }

    if (values["ticketdesc"] && MAXLENOBJ) {
      if (values["ticketdesc"].length > MAXLENOBJ.ticketdesc) {
        errors["ticketdesc"] =
          LocaleStrings.max_characters_left + MAXLENOBJ.ticketdesc;
      }
    }
  }
  // console.log("errors :- ", errors);
  return errors;
}

export default connect(mapStateToProps, {
  addTicket,
  updateTicket,
  showError,
  showSuccess,
  openTicketModal,
  editTicket,
  ticketnameExist,
  openUserCategoryModal,
  checkTicketDaschoardStatus,
})(
  reduxForm({
    validate,
    form: "TicketForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(AddTicket)
);

class AddTicketForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      starttime: { start: "0:00", end: "23:55" },
      endtime: { start: "0:05", end: "23:55" },
      step: 5,
      displayPrice: true,
      ticketPrice: "-",
      taxPercentage: props.tax,
      taxName: props.taxname,
      taxAmount: "-",
      eventifyfee: "-",
      stripefee: "-",
      clientpay: "-",
      hostget: "-",
      feePaymentType: props.initialValues.feesetting,
      selectedCurrency: props.initialValues.currency,
      isHideAmountInfoSection:
        props.initialValues.currency == "ZAR" ? true : false,
      tracking_toogle: false,
      displayColorPicker: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    let {
      tickettype,
      price,
      currency,
      owntaxname,
      owntaxrate,
      feesetting,
      tax, // Global tax rate
      taxname, // Global tax name
      stripeCurrencyDetailsList,
    } = this.props;

    if (
      nextProps.tickettype !== tickettype ||
      nextProps.price !== price ||
      nextProps.currency !== currency ||
      nextProps.owntaxname !== owntaxname ||
      nextProps.owntaxrate !== owntaxrate ||
      nextProps.feesetting !== feesetting
    ) {
      if (nextProps.tickettype === "free") {
        this.setState({
          displayPrice: false,
          ticketPrice: "-",
          taxPercentage: 0,
          taxName: "-",
          taxAmount: "-",
          eventifyfee: "-",
          stripefee: "-",
          clientpay: "-",
          hostget: "-",
        });
      } else {
        let ticketprice = parseFloat(nextProps.price);
        if (ticketprice > 0) {
          // Stripe and eventify fee calculation according to currency (Dynamic)
          let currencyDetails = _.filter(stripeCurrencyDetailsList, (curr) => {
            return curr.currency == nextProps.currency;
          });

          let application_fee =
            currencyDetails.length > 0 ? currencyDetails[0].application_fee : 0;
          let stripe_fixed =
            currencyDetails.length > 0 ? currencyDetails[0].stripe_fixed : 0;
          let stripe_percentage =
            currencyDetails.length > 0
              ? currencyDetails[0].stripe_percentage
              : 0;
          // ------------------------------------ //

          let feePaymentType = nextProps.feesetting;
          let taxrate =
            nextProps.owntaxrate && nextProps.owntaxrate > 0
              ? nextProps.owntaxrate
              : tax;
          let taxtype =
            nextProps.owntaxname && nextProps.owntaxname != ""
              ? nextProps.owntaxname
              : taxname;
          let taxamount =
            taxtype && taxtype != "" && taxrate && taxrate > 0
              ? (taxrate * ticketprice) / 100
              : 0;
          let applicationfee = application_fee;
          let paymentgatewayfee =
            (stripe_percentage *
              (parseFloat(ticketprice) + parseFloat(taxamount))) /
              100 +
            stripe_fixed;

          let clientpay = "-";
          let hostamount = "-";
          if (feePaymentType === "absorb") {
            clientpay = parseFloat(ticketprice) + parseFloat(taxamount);
            hostamount = clientpay - applicationfee - paymentgatewayfee;

            ticketprice = ticketprice.toFixed(2);
            taxamount = taxamount.toFixed(2);
            applicationfee = applicationfee.toFixed(2);
            paymentgatewayfee = paymentgatewayfee.toFixed(2);
            clientpay = clientpay.toFixed(2);
            hostamount = hostamount.toFixed(2);
          } else {
            clientpay =
              parseFloat(ticketprice) +
              parseFloat(taxamount) +
              parseFloat(paymentgatewayfee) +
              parseFloat(applicationfee);
            hostamount = parseFloat(ticketprice) + parseFloat(taxamount);

            ticketprice = ticketprice.toFixed(2);
            taxamount = taxamount.toFixed(2);
            applicationfee = applicationfee.toFixed(2);
            paymentgatewayfee = paymentgatewayfee.toFixed(2);
            clientpay = clientpay.toFixed(2);
            hostamount = hostamount.toFixed(2);
          }

          this.setState({
            ticketPrice: ticketprice,
            taxPercentage: taxrate,
            taxName: taxtype,
            taxAmount: taxamount,
            eventifyfee: applicationfee,
            stripefee: paymentgatewayfee,
            clientpay: clientpay,
            hostget: hostamount,
          });
        }
      }
    }
  }

  // componentDidMount() {
  //   let { initialValues, editMode, stripeCurrencyDetailsList, owntaxrate } =
  //     this.props;
  //   let { taxName, taxPercentage } = this.state;
  //   console.log("......", taxName, taxPercentage, owntaxrate, initialValues);

  //   if (editMode) {
  //     if (
  //       initialValues &&
  //       initialValues.tickettype &&
  //       initialValues.tickettype === "free"
  //     ) {
  //       this.setState({
  //         displayPrice: false,
  //         ticketPrice: "-",
  //         taxAmount: "-",
  //         eventifyfee: "-",
  //         stripefee: "-",
  //         clientpay: "-",
  //         hostget: "-",
  //       });
  //     } else if (initialValues && initialValues.price) {
  //       // Stripe and eventify fee calculation according to currency (Dynamic)
  //       let currencyDetails = _.filter(stripeCurrencyDetailsList, (curr) => {
  //         return curr.currency == this.state.selectedCurrency;
  //       });

  //       let application_fee =
  //         currencyDetails.length > 0 ? currencyDetails[0].application_fee : 0;
  //       let stripe_fixed =
  //         currencyDetails.length > 0 ? currencyDetails[0].stripe_fixed : 0;
  //       let stripe_percentage =
  //         currencyDetails.length > 0 ? currencyDetails[0].stripe_percentage : 0;
  //       // ------------------------------------ //

  //       let feePaymentType = initialValues.feesetting;
  //       let ticketprice = initialValues.price;
  //       let taxamount =
  //         taxName && taxPercentage && taxPercentage > 0
  //           ? (taxPercentage * ticketprice) / 100
  //           : 0;
  //       let applicationfee = application_fee;
  //       let paymentgatewayfee =
  //         (stripe_percentage *
  //           (parseFloat(ticketprice) + parseFloat(taxamount))) /
  //           100 +
  //         stripe_fixed;
  //       let clientpay = "-";
  //       let hostamount = "-";
  //       if (feePaymentType === "absorb") {
  //         clientpay = parseFloat(ticketprice) + parseFloat(taxamount);
  //         hostamount = clientpay - applicationfee - paymentgatewayfee;

  //         ticketprice = ticketprice.toFixed(2);
  //         taxamount = taxamount.toFixed(2);
  //         applicationfee = applicationfee.toFixed(2);
  //         paymentgatewayfee = paymentgatewayfee.toFixed(2);
  //         clientpay = clientpay.toFixed(2);
  //         hostamount = hostamount.toFixed(2);
  //       } else {
  //         clientpay =
  //           parseFloat(ticketprice) +
  //           parseFloat(taxamount) +
  //           parseFloat(paymentgatewayfee) +
  //           parseFloat(applicationfee);
  //         hostamount = parseFloat(ticketprice) + parseFloat(taxamount);

  //         ticketprice = ticketprice.toFixed(2);
  //         taxamount = taxamount.toFixed(2);
  //         applicationfee = applicationfee.toFixed(2);
  //         paymentgatewayfee = paymentgatewayfee.toFixed(2);
  //         clientpay = clientpay.toFixed(2);
  //         hostamount = hostamount.toFixed(2);
  //       }
  //       console.log("paymentgatewayfee :- ", paymentgatewayfee);
  //       this.setState({
  //         ticketPrice: ticketprice,
  //         taxAmount: taxamount,
  //         eventifyfee: applicationfee,
  //         stripefee: paymentgatewayfee,
  //         clientpay: clientpay,
  //         hostget: hostamount,
  //       });
  //     }
  //   }
  // }

  handlePickerClose() {
    this.setState({ displayColorPicker: false });
  }

  handlePickerClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleColorChange = (e) => {
    // console.log("e :- ", e);

    this.props.autofill("colorcode", e.hex);
  };

  changePriceTag = (e) => {
    var selected = e.target.value;

    if (selected == "free") {
      this.setState({
        displayPrice: false,
        eventifyfee: "-",
        stripefee: "-",
        clientpay: "-",
        hostget: "-",
        taxAmount: "-",
        ticketPrice: "-",
      });
      this.props.change("price", "");
      this.props.untouch("price");
      this.props.change("taxname", "");
      this.props.change("tax", "");
    } else {
      this.setState({
        displayPrice: true,
      });
    }
  };

  handleCurrency = (e) => {
    var currency = e.target.value;

    if (currency == "ZAR") {
      this.setState({ isHideAmountInfoSection: true });
    } else {
      this.setState({ isHideAmountInfoSection: false });
    }

    // this.setState({ selectedCurrency: currency }, this.finalCalculation);
    this.setState({ selectedCurrency: currency });
  };

  priceCalc = (e) => {
    let ticketprice = e.target.value;

    // this.setState({ ticketPrice: ticketprice }, this.finalCalculation);
    this.setState({ ticketPrice: ticketprice });
  };

  updateFeePaymentType = (e) => {
    let key = e.target.attributes["data-key"].value;
    this.props.autofill("feesetting", key);

    // this.setState({ feePaymentType: key }, this.finalCalculation);
    this.setState({ feePaymentType: key });
  };

  finalCalculation = () => {
    let { ticketPrice, feePaymentType, selectedCurrency } = this.state;
    let taxamount = "-";
    let applicationfee = "-";
    let paymentgatewayfee = "-";
    let clientpay = "-";
    let hostamount = "-";

    if (parseFloat(ticketPrice) > 0) {
      // Stripe and eventify fee calculation according to currency (Dynamic)
      let currencyDetails = _.filter(
        this.props.stripeCurrencyDetailsList,
        (curr) => {
          return curr.currency == selectedCurrency;
        }
      );
      let application_fee =
        currencyDetails.length > 0 ? currencyDetails[0].application_fee : 0;
      let stripe_fixed =
        currencyDetails.length > 0 ? currencyDetails[0].stripe_fixed : 0;
      let stripe_percentage =
        currencyDetails.length > 0 ? currencyDetails[0].stripe_percentage : 0;
      // ------------------------------------ //

      // applicationfee = EVENTIFY_FEE;
      // paymentgatewayfee = ((STRIPE_FEE * ticketPrice)/100) + STRIPE_FEE_EXTRA;
      taxamount = (this.state.taxPercentage * ticketPrice) / 100;
      applicationfee = application_fee;
      paymentgatewayfee =
        (stripe_percentage *
          (parseFloat(ticketPrice) + parseFloat(taxamount))) /
          100 +
        stripe_fixed;

      if (feePaymentType === "absorb") {
        clientpay = parseFloat(ticketPrice) + parseFloat(taxamount);
        hostamount = clientpay - applicationfee - paymentgatewayfee;

        ticketPrice = parseFloat(ticketPrice).toFixed(2);
        taxamount = taxamount.toFixed(2);
        applicationfee = applicationfee.toFixed(2);
        paymentgatewayfee = paymentgatewayfee.toFixed(2);
        clientpay = clientpay.toFixed(2);
        hostamount = hostamount.toFixed(2);
      } else {
        clientpay =
          parseFloat(ticketPrice) +
          parseFloat(taxamount) +
          parseFloat(applicationfee) +
          parseFloat(paymentgatewayfee);
        hostamount = parseFloat(ticketPrice) + parseFloat(taxamount);

        ticketPrice = parseFloat(ticketPrice).toFixed(2);
        taxamount = taxamount.toFixed(2);
        applicationfee = applicationfee.toFixed(2);
        paymentgatewayfee = paymentgatewayfee.toFixed(2);
        clientpay = clientpay.toFixed(2);
        hostamount = hostamount.toFixed(2);
      }
    }
    this.setState({
      taxAmount: taxamount,
      eventifyfee: applicationfee,
      stripefee: paymentgatewayfee,
      clientpay: clientpay,
      hostget: hostamount,
    });
  };

  handleChildTicket = (e) => {
    var { allTicketList } = this.props;
    var childTicket = e.target.value;
    var matchTickets = _.filter(allTicketList, (obj) => {
      return obj.id == childTicket;
    });

    if (matchTickets.length > 0) {
      var ddstend = matchTickets[0].saleenddate.split(" ");
      var edate = moment(ddstend[0]).format(DATE_FORMAT);
      var etime = ddstend[1];

      this.props.autofill("enddate", edate);
      this.props.autofill("endtime", etime);
    }
  };

  taxHtml = () => {
    var style = { width: 700 };

    return (
      <Popover title={LocaleStrings.tax} id="popover-basic-tax" style={style}>
        {!this.state.displayPrice ||
        (this.state.taxPercentage > 0 && this.state.taxName != "") ? (
          <>
            {/* <div className="row">
              <label className="col-md-9 text-left">
                {" "}
                {this.state.taxName}{" "}
              </label>
              <div className="col-md-3 text-right">{this.state.taxAmount}</div>
            </div> */}

            <PopoverHeader>
              <h3 className="popover-title px-0">{this.state.taxName}</h3>
            </PopoverHeader>

            <PopoverBody>
              <div>{this.state.taxAmount}</div>
            </PopoverBody>
          </>
        ) : (
          <>
            <PopoverHeader>
              <h3 className="popover-title px-0">{LocaleStrings.tax}</h3>
            </PopoverHeader>
            <PopoverBody>
              <div style={{ fontWeight: 600 }}>
                {LocaleStrings.tickets_ticket_form_text_set_your_tax_nav}
              </div>
            </PopoverBody>
          </>
        )}
      </Popover>
    );
  };

  feeHtml = () => {
    var style = { width: 700 };
    // Stripe and eventify fee calculation according to currency (Dynamic)
    let currencyDetails = _.filter(
      this.props.stripeCurrencyDetailsList,
      (curr) => {
        return curr.currency == this.state.selectedCurrency;
      }
    );
    let stripe_fixed =
      currencyDetails.length > 0 ? currencyDetails[0].stripe_fixed : 0;
    let stripe_percentage =
      currencyDetails.length > 0 ? currencyDetails[0].stripe_percentage : 0;
    // ------------------------------------ //

    return (
      <Popover
        title={LocaleStrings.fee}
        id="popover-basic-preview-"
        style={style}
      >
        <PopoverHeader>
          <h3 className="popover-title px-0">{LocaleStrings.fee}</h3>
        </PopoverHeader>

        <PopoverBody>
          <div className="row">
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_table_list_eventify_fee}{" "}
            </label>
            <div className="col-md-3 text-right">{this.state.eventifyfee}</div>
          </div>
          <hr style={{ margin: 0 }} />
          <div className="row">
            {/* {" "}
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_table_list_stripe_fee} (
              {STRIPE_FEE}% + {STRIPE_FEE_EXTRA}&euro;){" "}
            </label> */}
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_table_list_stripe_fee} (
              {stripe_percentage}% + {stripe_fixed}&euro;){" "}
            </label>
            <div className="col-md-3 text-right">{this.state.stripefee}</div>
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  paymentDetailsHtml = () => {
    var { taxName, taxAmount } = this.state;
    var style = { width: 700 };

    return (
      <Popover
        title={LocaleStrings.tickets_ticket_form_text_payment_breakdown}
        id="popover-basic-payment-details"
        style={style}
      >
        <PopoverHeader>
          <h3 className="popover-title px-0">
            {LocaleStrings.tickets_ticket_form_text_payment_breakdown}
          </h3>
        </PopoverHeader>
        <PopoverBody>
          <div className="row">
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_text_ticket_price}{" "}
            </label>
            <div className="col-md-3 text-right">
              {this.state.ticketPrice != "-"
                ? parseFloat(this.state.ticketPrice).toFixed(2)
                : this.state.ticketPrice}
            </div>
          </div>
          <hr style={{ margin: 0 }} />
          {!this.state.displayPrice ||
          (this.state.taxPercentage > 0 && this.state.taxName != "") ? (
            <div className="row">
              <label className="col-md-9 text-left"> {taxName} </label>
              <div className="col-md-3 text-right">{taxAmount}</div>
              <hr style={{ margin: 0 }} />
            </div>
          ) : null}
          <div className="row">
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_text_eventify_fee}{" "}
            </label>
            <div className="col-md-3 text-right">{this.state.eventifyfee}</div>
          </div>
          <hr style={{ margin: 0 }} />
          <div className="row">
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_text_payment_getway_fee}{" "}
            </label>
            <div className="col-md-3 text-right">{this.state.stripefee}</div>
          </div>
          <hr style={{ margin: 0 }} />
          <div className="row">
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_text_client_pay}{" "}
            </label>
            <div className="col-md-3 text-right">{this.state.clientpay}</div>
          </div>
          <hr style={{ margin: 0 }} />
          <div className="row">
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_text_money_to_you}{" "}
            </label>
            <div className="col-md-3 text-right">{this.state.hostget}</div>
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  renderTimeField = (field) => {
    var divClassName = `form-group row ${field.meta.error ? "has-danger" : ""}`;

    return (
      <div className={divClassName}>
        <div className="col-sm-12 col-sm-offset-0">
          <TimePicker
            start={field.start}
            end={field.end}
            step={field.step}
            disabled={field.disabled}
            className="form-control dropdown-height-border"
            placeholder={field.placeholder}
            {...field.input}
          />
          <div className="text-help label-text-help">
            {field.meta.error ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  };

  render() {
    let {
      userCategoryList,
      showModal,
      allTicketList,
      currencyList,
      totalFormBuildeList,
      editMode,
      initialValues,
    } = this.props;
    let {
      feePaymentType,
      selectedCurrency,
      isHideAmountInfoSection,
      displayPrice,
      displayColorPicker,
    } = this.state;
    let minDate = moment();
    let categories = [
      { name: LocaleStrings.paid, value: "paid" },
      { name: LocaleStrings.free, value: "free" },
    ];
    let currencyDropList = [];
    var formsDropList = [];
    var today = moment().format(DATE_FORMAT_WITH_TIME);

    _.map(currencyList, (tindex) => {
      currencyDropList.push({ name: tindex.code, value: tindex.code });
    });

    _.map(totalFormBuildeList, (form) => {
      // var name = form.formname + " (" + form.formnumber + ")";
      var name = form.formname;
      formsDropList.push({ name: name, value: form.formid });
    });

    var userCategoriesWIthoutAdmin = _.filter(userCategoryList.data, (obj) => {
      return obj.type != "admin";
    });
    var userCategories = [];
    userCategoriesWIthoutAdmin.forEach((item, index) => {
      var obj = { label: item.groupname, value: item.id.toString() };
      userCategories.push(obj);
    });

    var attendeeTickets = allTicketList
      ? _.filter(allTicketList, (obj) => {
          return !obj.childticketid && obj.type === "general";
        })
      : [];
    var attendeeOpt = [
      {
        name: LocaleStrings.tickets_ticket_form_ph_child_attendee_ticket,
        value: "",
      },
    ];
    attendeeTickets.forEach((item, index) => {
      var validDate = moment(item.saleenddate).isAfter(today, "hours");

      if (item.status != "disabled" && validDate) {
        var obj = { name: item.ticketname, value: item.id };
        attendeeOpt.push(obj);
      }
    });

    let absorb = "btn btn-custom-blue";
    let passon = "btn btn-custom-white";
    if (feePaymentType != "absorb") {
      absorb = "btn btn-custom-white";
      passon = "btn btn-custom-blue";
    }

    let infoIconeStyle = {
      color: "#2676ea",
      fontSize: 15,
      paddingLeft: 10,
      paddingRight: 10,
    };
    let taxInfoIconeStyle = { color: "#2676ea", size: 30, paddingLeft: 10 };

    // tracking toggler
    let trackingStyle = "fa fa-chevron-circle-down";
    let trackingActive = "";
    if (this.state.tracking_toogle) {
      trackingStyle = "fa fa-chevron-circle-up";
      trackingActive = "activeup";
    }

    return (
      <div className="basicform">
        {editMode && initialValues.tickecode ? (
          <div className="form-group row">
            <label className="control-label-top col-sm-12">
              {LocaleStrings.tickets_ticket_form_label_ticket_code}
            </label>

            <div className="col-sm-12">
              <div className="input-type-div">{initialValues.tickecode}</div>
            </div>
          </div>
        ) : (
          ""
        )}

        {showModal.genre === "addon" ? (
          ""
        ) : (
          <Field
            name="formid"
            label={
              showModal.category === "exhibitor"
                ? LocaleStrings.tickets_ticket_form_label_exhibitor_checkout_name
                : showModal.category === "sponsor"
                ? LocaleStrings.tickets_ticket_form_label_sponsor_checkout_name
                : LocaleStrings.tickets_ticket_form_label_checkout_name
            }
            // placeholder={
            //   showModal.category === "exhibitor"
            //     ? LocaleStrings.tickets_ticket_form_ph_exhibitor_checkout_name
            //     : showModal.category === "sposnor"
            //     ? LocaleStrings.tickets_ticket_form_ph_sponsor_checkout_name
            //     : LocaleStrings.tickets_ticket_form_ph_checkout_name
            // }
            type="select"
            mandatory="true"
            component={this.renderSelect}
            opts={formsDropList}
            labelposition={LABEL_POSITION_TOP}
            // disabled={this.props.editMode}
          />
        )}

        {/* <Field
          name="usercategory"
          label={LocaleStrings.user_form_label_category}
          placeholder={LocaleStrings.user_form_label_category_placeholder}
          type="select"
          // mandatory='true'
          labelposition={LABEL_POSITION_TOP}
          component={this.renderReactMultiSelectCheckboxesWithManageButton}
          opts={userCategories}
          onManageClick={this.props.onManageCategory}
        /> */}

        <Field
          name="ticketname"
          label={LocaleStrings.tickets_ticket_form_label_ticket_name}
          placeholder={LocaleStrings.tickets_ticket_form_ph_ticket_name}
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          maxlength={MAXLENOBJ.ticketname ? MAXLENOBJ.ticketname : ""}
          labelposition={LABEL_POSITION_TOP}
          // disabled={this.props.editMode}
        />
        {this.props.dateError.ticketnameerror !== "" ? (
          <div style={{ paddingLeft: 15 }}>
            <span style={{ color: "#d43f3a" }}>
              {this.props.dateError.ticketnameerror}
            </span>
          </div>
        ) : (
          ""
        )}
        <Field
          name="tickettag"
          label={LocaleStrings.tickets_ticket_form_label_ticket_tag}
          placeholder={LocaleStrings.tickets_ticket_form_ph_ticket_tag}
          type="text"
          component={this.renderFieldText}
          mandatory="false"
          maxlength={MAXLENOBJ.tickettag ? MAXLENOBJ.tickettag : ""}
          labelposition={LABEL_POSITION_TOP}
          // disabled={this.props.editMode}
        />

        <Field
          name="colorcode"
          label={LocaleStrings.tickets_ticket_form_label_color}
          placeholder={LocaleStrings.tickets_ticket_form_ph_color}
          type="text"
          mandatory="true"
          component={this.renderColorPickerField}
          labelposition={LABEL_POSITION_TOP}
          onClick={this.handlePickerClick.bind(this)}
          displayColorPicker={displayColorPicker}
          onChangeComplete={this.handleColorChange.bind(this)}
          handlePickerClose={this.handlePickerClose.bind(this)}
        />

        {showModal.category === "exhibitor" ||
        showModal.category === "sponsor" ? (
          <>
            <Field
              name="noofchildtickets"
              label={
                showModal.category === "exhibitor"
                  ? LocaleStrings.tickets_ticket_form_label_exhibitor_no_child_attendee_ticket
                  : LocaleStrings.tickets_ticket_form_label_sponsor_no_child_attendee_ticket
              }
              placeholder={
                showModal.category === "exhibitor"
                  ? LocaleStrings.tickets_ticket_form_ph_exhibitor_no_child_attendee_ticket
                  : LocaleStrings.tickets_ticket_form_ph_sponsor_no_child_attendee_ticket
              }
              type="number"
              mandatory="false"
              component={this.renderFieldText}
              labelposition={LABEL_POSITION_TOP}
              // disabled={this.props.editMode}
            />

            <Field
              name="childticketid"
              label={
                LocaleStrings.tickets_ticket_form_label_child_attendee_ticket
              }
              // placeholder={
              //   LocaleStrings.tickets_ticket_form_ph_child_attendee_ticket
              // }
              mandatory="true"
              component={this.renderSelect}
              opts={attendeeOpt}
              onChange={this.handleChildTicket}
              labelposition={LABEL_POSITION_TOP}
              // disabled={this.props.editMode}
            />
          </>
        ) : (
          ""
        )}

        <Field
          name="quantity"
          label={LocaleStrings.tickets_ticket_form_label_ticket_quantity}
          placeholder={LocaleStrings.tickets_ticket_form_ph_ticket_quantity}
          type="number"
          component={this.renderFieldText}
          mandatory="true"
          min="1"
          labelposition={LABEL_POSITION_TOP}
        />
        {this.props.dateError.quantityerror !== "" ? (
          <div style={{ paddingLeft: 15 }}>
            <span style={{ color: "#d43f3a" }}>
              {this.props.dateError.quantityerror}
            </span>
          </div>
        ) : (
          ""
        )}

        {showModal.category === "exhibitor" ||
        showModal.category === "sponsor" ? (
          ""
        ) : (
          <>
            <Field
              name="minbooking"
              label={LocaleStrings.tickets_ticket_form_label_min_booking}
              placeholder={LocaleStrings.tickets_ticket_form_ph_min_booking}
              type="number"
              min="1"
              component={this.renderFieldText}
              mandatory="true"
              labelposition={LABEL_POSITION_TOP}
              // disabled={this.props.editMode}
            />

            <Field
              name="maxbooking"
              label={LocaleStrings.tickets_ticket_form_label_max_booking}
              placeholder={LocaleStrings.tickets_ticket_form_ph_max_booking}
              type="number"
              min="1"
              component={this.renderFieldText}
              mandatory="true"
              labelposition={LABEL_POSITION_TOP}
              // disabled={this.props.editMode}
            />
          </>
        )}

        <Field
          name="tickettype"
          label={LocaleStrings.tickets_ticket_form_label_ticket_type}
          // placeholder={LocaleStrings.tickets_ticket_form_ph_ticket_type}
          type="select"
          mandatory="true"
          component={this.renderSelect}
          opts={categories}
          onChange={this.changePriceTag}
          labelposition={LABEL_POSITION_TOP}
          // disabled={this.props.editMode}
        />

        {displayPrice ? (
          <>
            <div className="form-group row">
              <label className="control-label-top col-sm-12">
                {LocaleStrings.tickets_ticket_form_label_ticket_price}
                <span className="label-mandatory">*</span>
              </label>

              <div className="col-md-6">
                <Field
                  name="currency"
                  placeholder={
                    LocaleStrings.tickets_ticket_form_ph_price_currency
                  }
                  type="select"
                  mandatory="true"
                  component={this.renderSelect}
                  opts={currencyDropList}
                  onChange={this.handleCurrency}
                  labelposition={LABEL_POSITION_TOP}
                  // disabled={this.props.editMode}
                />
              </div>

              <div className="col-md-6">
                <Field
                  name="price"
                  label={""}
                  placeholder={LocaleStrings.tickets_ticket_form_ph_price}
                  type="number"
                  min="1"
                  component={this.renderFieldText}
                  onChange={this.priceCalc}
                  parse={(val) => (val ? parseFloat(val, 2) : "")}
                  labelposition={LABEL_POSITION_TOP}
                  step="0.01"
                  // disabled={this.props.editMode}
                />
              </div>

              {/* <div className="col-md-2 vcenter">
                + {LocaleStrings.tax}
                <OverlayTrigger
                  trigger="click"
                  placement="left"
                  rootClose
                  overlay={this.taxHtml()}
                >
                  <i
                    className="fa fa-info-circle cursor-pointer"
                    style={taxInfoIconeStyle}
                  ></i>
                </OverlayTrigger>
              </div> */}
            </div>

            <div className="form-group row">
              <div className="col-md-12">
                <Field
                  name="isofflinepayment"
                  label={
                    LocaleStrings.tickets_ticket_form_label_is_payment_offline
                  }
                  type="checkbox"
                  component={this.renderFieldCheckbox}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <Field
                  name="taxname"
                  label={LocaleStrings.tickets_ticket_form_label_tax_name}
                  placeholder={LocaleStrings.tickets_ticket_form_ph_tax_name}
                  type="text"
                  component={this.renderFieldText}
                  maxlength={MAXLENOBJ.taxname ? MAXLENOBJ.taxname : ""}
                  labelposition={LABEL_POSITION_TOP}
                />
              </div>
              <div className="col-md-6">
                <Field
                  name="tax"
                  label={LocaleStrings.tickets_ticket_form_label_tax_percentage}
                  placeholder={
                    LocaleStrings.tickets_ticket_form_ph_tax_percentage
                  }
                  type="text"
                  min={1}
                  max={30}
                  component={this.renderFieldText}
                  labelposition={LABEL_POSITION_TOP}
                />
              </div>
            </div>
          </>
        ) : (
          ""
        )}

        {this.state.displayPrice && isHideAmountInfoSection == false ? (
          <div className="form-group row">
            <div className="col-md-6">
              <label className="control-label-top col-sm-12">
                {LocaleStrings.fee}
                <OverlayTrigger
                  trigger="click"
                  placement="left"
                  rootClose
                  overlay={this.feeHtml()}
                >
                  <i
                    className="fa fa-info-circle cursor-pointer"
                    style={infoIconeStyle}
                  ></i>
                </OverlayTrigger>
              </label>

              <div className="col-md-12">
                <div
                  className="btn-group mr-2"
                  role="group"
                  aria-label="First group"
                >
                  <button
                    type="button"
                    data-key="absorb"
                    className={absorb}
                    onClick={this.updateFeePaymentType}
                  >
                    {LocaleStrings.tickets_ticket_form_text_feepayment_absorb}
                  </button>
                  <button
                    type="button"
                    data-key="passon"
                    className={passon}
                    onClick={this.updateFeePaymentType}
                  >
                    {LocaleStrings.tickets_ticket_form_text_feepayment_passon}
                  </button>
                </div>

                <Field
                  name="feesetting"
                  type="text"
                  component={this.renderHiddenFieldText}
                />
              </div>
            </div>

            <div className="col-md-6">
              <label className="control-label-top col-sm-12">
                {LocaleStrings.tickets_ticket_form_text_money_to_you}
              </label>
              <div className="col-md-12" style={{ fontSize: 25 }}>
                {selectedCurrency} {this.state.hostget}
                <OverlayTrigger
                  trigger="click"
                  placement="right"
                  rootClose
                  overlay={this.paymentDetailsHtml()}
                >
                  <i
                    className="fa fa-info-circle cursor-pointer"
                    style={infoIconeStyle}
                  ></i>
                </OverlayTrigger>
              </div>
            </div>
          </div>
        ) : null}

        <div className="row">
          <label className="control-label-top col-sm-12">
            {LocaleStrings.tickets_ticket_form_label_sale_start_from}
            <span className="label-mandatory">*</span>
          </label>
          <div className="col-lg-12 col-md-12 col-sm-12 col-sm-offset-0">
            <div className="row">
              <div className="col-md-7" style={{ paddingRight: 0 }}>
                <Field
                  name="startdate"
                  type="text"
                  component={this.renderDatePicker}
                  mandatory="true"
                  minDate={minDate}
                />
              </div>
              <div
                className="col-md-5"
                style={{ paddingLeft: 5, paddingRight: 0 }}
              >
                <Field
                  name="starttime"
                  type="text"
                  mandatory="true"
                  start={this.state.starttime.start}
                  end={this.state.starttime.end}
                  component={this.renderTimeField}
                  step={this.state.step}
                />
              </div>
            </div>
            {this.props.dateError.startdateError !== "" ? (
              <span style={{ color: "#d43f3a" }}>
                {this.props.dateError.startdateError}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="row">
          <label className="control-label-top col-sm-12">
            {LocaleStrings.tickets_ticket_form_label_sale_ends_at}
            <span className="label-mandatory">*</span>
          </label>

          <div className="col-lg-12 col-md-12 col-sm-12 col-sm-offset-0">
            <div className="row">
              <div className="col-md-7">
                <Field
                  name="enddate"
                  type="text"
                  component={this.renderDatePicker}
                  mandatory="true"
                  minDate={minDate}
                />
              </div>
              <div className="col-md-5">
                <Field
                  name="endtime"
                  type="text"
                  mandatory="true"
                  start={this.state.endtime.start}
                  end={this.state.endtime.end}
                  component={this.renderTimeField}
                  step={this.state.step}
                />
              </div>
              <div className="col-md-12">
                <Field
                  name="dateerror"
                  type="text"
                  component={this.renderHiddenFieldText}
                />
              </div>
            </div>
            {this.props.dateError.enddateError !== "" ? (
              <span style={{ color: "#d43f3a" }}>
                {this.props.dateError.enddateError}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>

        <Field
          name="ticketdesc"
          label={LocaleStrings.tickets_ticket_form_label_ticket_description}
          placeholder={LocaleStrings.tickets_ticket_form_ph_ticket_description}
          component={this.renderFieldTextarea}
          mandatory="true"
          maxlength={MAXLENOBJ.ticketdesc ? MAXLENOBJ.ticketdesc : ""}
          labelposition={LABEL_POSITION_TOP}
          // disabled={this.props.editMode}
        />

        <div className="form-group row">
          <label className="control-label-top col-sm-12">
            {LocaleStrings.tickets_ticket_form_label_ticket_status}
            <span className="label-mandatory">*</span>
          </label>
          <div className="col-md-12 d-flex">
            <Field
              name="status"
              label={
                LocaleStrings.tickets_ticket_form_label_ticket_status_option1
              }
              component={this.renderFieldRadio}
              type="radio"
              value="enabled"
            />{" "}
            <Field
              name="status"
              label={
                LocaleStrings.tickets_ticket_form_label_ticket_status_option2
              }
              component={this.renderFieldRadio}
              type="radio"
              value="disabled"
            />{" "}
            <Field
              name="status"
              label={
                LocaleStrings.tickets_ticket_form_label_ticket_status_option3
              }
              component={this.renderFieldRadio}
              type="radio"
              value="hidden"
            />
          </div>
          <div className="col-md-12">
            <Field
              name="statuserror"
              component={this.renderHiddenFieldText}
              type="input"
            />
          </div>
        </div>

        {/* --- Tracking code manage --- */}
        <div
          className="dashboard-steps"
          data-data_id="Step1"
          onClick={() =>
            this.setState({
              tracking_toogle: !this.state.tracking_toogle,
            })
          }
          style={{ display: "flex" }}
        >
          <div style={{ width: "93%" }}>
            <h6 className="control-label-top col-sm-12 label-mandatory">
              {LocaleStrings.tickets_ticket_form_trackingpixel_caution_text}
            </h6>
          </div>
          <div className={trackingActive} style={{ fontSize: 24 }}>
            <i className={trackingStyle} aria-hidden="false"></i>
          </div>
        </div>

        {/* --- Tracking pixel code field --- */}
        {this.state.tracking_toogle ? (
          <>
            <Field
              name="ticket_tracking_header"
              label={
                LocaleStrings.tickets_ticket_form_label_trackingpixel_header
              }
              placeholder={LocaleStrings.tickets_ticket_form_ph_trackingpixel}
              component={this.renderFieldTextarea}
              labelposition={LABEL_POSITION_TOP}
            />
            <Field
              name="ticket_tracking_footer"
              label={
                LocaleStrings.tickets_ticket_form_label_trackingpixel_footer
              }
              placeholder={LocaleStrings.tickets_ticket_form_ph_trackingpixel}
              component={this.renderFieldTextarea}
              labelposition={LABEL_POSITION_TOP}
            />

            <label className="control-lable-top col-sm-12">
              {LocaleStrings.tickets_trackingpixel_cautionary_text}
            </label>
          </>
        ) : (
          <></>
        )}
      </div>
    );
  }
}

class AddPlanForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      displayPrice: true,
      taxPercentage: props.tax,
      ticketPrice: "-",
      taxName: props.taxname,
      taxAmount: "-",
      eventifyfee: "-",
      stripefee: "-",
      clientpay: "-",
      hostget: "-",
      feePaymentType: props.initialValues.feesetting,
      selectedCurrency: props.initialValues.currency,
      isHideAmountInfoSection:
        props.initialValues.currency == "ZAR" ? true : false,
    };
  }

  componentDidMount() {
    if (this.props.editMode) {
      if (
        this.props.initialValues &&
        this.props.initialValues.tickettype &&
        this.props.initialValues.tickettype == "free"
      ) {
        this.setState({
          displayPrice: false,
          ticketPrice: "-",
          taxAmount: "-",
          eventifyfee: "-",
          stripefee: "-",
          clientpay: "-",
          hostget: "-",
        });
      } else if (this.props.initialValues && this.props.initialValues.price) {
        // Stripe and eventify fee calculation according to currency (Dynamic)
        let currencyDetails = _.filter(
          this.props.stripeCurrencyDetailsList,
          (curr) => {
            return curr.currency == this.state.selectedCurrency;
          }
        );
        let application_fee =
          currencyDetails.length > 0 ? currencyDetails[0].application_fee : 0;
        let stripe_fixed =
          currencyDetails.length > 0 ? currencyDetails[0].stripe_fixed : 0;
        let stripe_percentage =
          currencyDetails.length > 0 ? currencyDetails[0].stripe_percentage : 0;
        // ------------------------------------ //

        let feePaymentType = this.props.initialValues.feesetting;
        let ticketprice = this.props.initialValues.price;
        let taxamount = (this.state.taxPercentage * ticketprice) / 100;
        // let applicationfee = EVENTIFY_FEE;
        // let paymentgatewayfee = ((STRIPE_FEE * ticketprice)/100) + STRIPE_FEE_EXTRA;
        let applicationfee = application_fee;
        let paymentgatewayfee =
          (stripe_percentage *
            (parseFloat(ticketprice) + parseFloat(taxamount))) /
            100 +
          stripe_fixed;
        let clientpay = "-";
        let hostamount = "-";
        if (feePaymentType === "absorb") {
          clientpay = parseFloat(ticketprice) + parseFloat(taxamount);
          hostamount = clientpay - applicationfee - paymentgatewayfee;

          ticketprice = ticketprice.toFixed(2);
          taxamount = taxamount.toFixed(2);
          applicationfee = applicationfee.toFixed(2);
          paymentgatewayfee = paymentgatewayfee.toFixed(2);
          clientpay = clientpay.toFixed(2);
          hostamount = hostamount.toFixed(2);
        } else {
          clientpay =
            parseFloat(ticketprice) +
            parseFloat(taxamount) +
            parseFloat(paymentgatewayfee) +
            parseFloat(applicationfee);
          hostamount = parseFloat(ticketprice) + parseFloat(taxamount);

          ticketprice = ticketprice.toFixed(2);
          taxamount = taxamount.toFixed(2);
          applicationfee = applicationfee.toFixed(2);
          paymentgatewayfee = paymentgatewayfee.toFixed(2);
          clientpay = clientpay.toFixed(2);
          hostamount = hostamount.toFixed(2);
        }
        this.setState({
          ticketPrice: ticketprice,
          taxAmount: taxamount,
          eventifyfee: applicationfee,
          stripefee: paymentgatewayfee,
          clientpay: clientpay,
          hostget: hostamount,
        });
      }
    }
  }

  changePriceTag = (e) => {
    var selected = e.target.value;

    if (selected == "free") {
      this.setState({
        displayPrice: false,
        eventifyfee: "-",
        stripefee: "-",
        clientpay: "-",
        hostget: "-",
        taxAmount: "-",
        ticketPrice: "-",
      });
      this.props.change("price", "");
      this.props.untouch("price");
    } else {
      this.setState({
        displayPrice: true,
      });
    }
  };

  handleCurrency = (e) => {
    var currency = e.target.value;

    if (currency == "ZAR") {
      this.setState({ isHideAmountInfoSection: true });
    } else {
      this.setState({ isHideAmountInfoSection: false });
    }

    this.setState({ selectedCurrency: currency }, this.finalCalculation);
  };

  priceCalc = (e) => {
    let ticketprice = e.target.value;

    this.setState({ ticketPrice: ticketprice }, this.finalCalculation);
  };

  finalCalculation = () => {
    let { ticketPrice, feePaymentType, selectedCurrency } = this.state;
    let taxamount = "-";
    let applicationfee = "-";
    let paymentgatewayfee = "-";
    let clientpay = "-";
    let hostamount = "-";

    if (parseFloat(ticketPrice) > 0) {
      // Stripe and eventify fee calculation according to currency (Dynamic)
      let currencyDetails = _.filter(
        this.props.stripeCurrencyDetailsList,
        (curr) => {
          return curr.currency == selectedCurrency;
        }
      );
      let application_fee =
        currencyDetails.length > 0 ? currencyDetails[0].application_fee : 0;
      let stripe_fixed =
        currencyDetails.length > 0 ? currencyDetails[0].stripe_fixed : 0;
      let stripe_percentage =
        currencyDetails.length > 0 ? currencyDetails[0].stripe_percentage : 0;
      // ------------------------------------ //

      // applicationfee = EVENTIFY_FEE;
      // paymentgatewayfee = ((STRIPE_FEE * ticketPrice)/100) + STRIPE_FEE_EXTRA;
      taxamount = (this.state.taxPercentage * ticketPrice) / 100;
      applicationfee = application_fee;
      paymentgatewayfee =
        (stripe_percentage *
          (parseFloat(ticketPrice) + parseFloat(taxamount))) /
          100 +
        stripe_fixed;

      if (feePaymentType === "absorb") {
        clientpay = parseFloat(ticketPrice) + parseFloat(taxamount);
        hostamount = clientpay - applicationfee - paymentgatewayfee;

        ticketPrice = parseFloat(ticketPrice).toFixed(2);
        taxamount = taxamount.toFixed(2);
        applicationfee = applicationfee.toFixed(2);
        paymentgatewayfee = paymentgatewayfee.toFixed(2);
        clientpay = clientpay.toFixed(2);
        hostamount = hostamount.toFixed(2);
      } else {
        clientpay =
          parseFloat(ticketPrice) +
          parseFloat(taxamount) +
          parseFloat(applicationfee) +
          parseFloat(paymentgatewayfee);
        hostamount = parseFloat(ticketPrice) + parseFloat(taxamount);

        ticketPrice = parseFloat(ticketPrice).toFixed(2);
        taxamount = taxamount.toFixed(2);
        applicationfee = applicationfee.toFixed(2);
        paymentgatewayfee = paymentgatewayfee.toFixed(2);
        clientpay = clientpay.toFixed(2);
        hostamount = hostamount.toFixed(2);
      }
    }
    this.setState({
      taxAmount: taxamount,
      eventifyfee: applicationfee,
      stripefee: paymentgatewayfee,
      clientpay: clientpay,
      hostget: hostamount,
    });
  };

  feeHtml = () => {
    var style = { width: 700 };
    // Stripe and eventify fee calculation according to currency (Dynamic)
    let currencyDetails = _.filter(
      this.props.stripeCurrencyDetailsList,
      (curr) => {
        return curr.currency == this.state.selectedCurrency;
      }
    );
    let stripe_fixed =
      currencyDetails.length > 0 ? currencyDetails[0].stripe_fixed : 0;
    let stripe_percentage =
      currencyDetails.length > 0 ? currencyDetails[0].stripe_percentage : 0;
    // ------------------------------------ //

    return (
      <Popover
        title={LocaleStrings.fee}
        id="popover-basic-preview-"
        style={style}
      >
        <PopoverHeader>
          <h3 className="popover-title px-0">{LocaleStrings.fee}</h3>
        </PopoverHeader>

        <PopoverBody>
          <div className="row">
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_table_list_eventify_fee}{" "}
            </label>
            <div className="col-md-3 text-right">{this.state.eventifyfee}</div>
          </div>
          <hr style={{ margin: 0 }} />
          <div className="row">
            {/* {" "}
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_table_list_stripe_fee} (
              {STRIPE_FEE}% + {STRIPE_FEE_EXTRA}&euro;){" "}
            </label> */}
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_table_list_stripe_fee} (
              {stripe_percentage}% + {stripe_fixed}&euro;){" "}
            </label>
            <div className="col-md-3 text-right">{this.state.stripefee}</div>
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  taxHtml = () => {
    var style = { width: 700 };

    return (
      <Popover title={LocaleStrings.tax} id="popover-basic-tax" style={style}>
        {!this.state.displayPrice ||
        (this.state.taxPercentage > 0 && this.state.taxName != "") ? (
          <>
            {/* <div className="row">
                <label className="col-md-9 text-left">
                  {" "}
                  {this.state.taxName}{" "}
                </label>
                <div className="col-md-3 text-right">
                  {this.state.taxAmount}
                </div>
              </div> */}

            <PopoverHeader>
              <h3 className="popover-title px-0">{this.state.taxName}</h3>
            </PopoverHeader>

            <PopoverBody>
              <div className="col-md-3 text-right">{this.state.taxAmount}</div>
            </PopoverBody>
          </>
        ) : (
          <>
            <PopoverHeader>
              <h3 className="popover-title px-0">{LocaleStrings.tax}</h3>
            </PopoverHeader>
            <PopoverBody>
              <div
                className="row"
                style={{ marginBottom: 20, fontWeight: 600 }}
              >
                <div className="col-md-12">
                  {LocaleStrings.tickets_ticket_form_text_set_your_tax_nav}
                </div>
              </div>
            </PopoverBody>
          </>
        )}
      </Popover>
    );
  };

  paymentDetailsHtml = () => {
    var { taxName, taxAmount } = this.state;
    var style = { width: 700 };

    return (
      <Popover
        title={LocaleStrings.tickets_ticket_form_text_payment_breakdown}
        id="popover-basic-payment-details"
        style={style}
      >
        <PopoverHeader>
          <h3 className="popover-title px-0">
            {LocaleStrings.tickets_ticket_form_text_payment_breakdown}
          </h3>
        </PopoverHeader>
        <PopoverBody>
          <div className="row">
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_text_ticket_price}{" "}
            </label>
            <div className="col-md-3 text-right">
              {this.state.ticketPrice != "-"
                ? parseFloat(this.state.ticketPrice).toFixed(2)
                : this.state.ticketPrice}
            </div>
          </div>
          <hr style={{ margin: 0 }} />
          {!this.state.displayPrice ||
          (this.state.taxPercentage > 0 && this.state.taxName != "") ? (
            <div className="row">
              <label className="col-md-9 text-left"> {taxName} </label>
              <div className="col-md-3 text-right">{taxAmount}</div>
              <hr style={{ margin: 0 }} />
            </div>
          ) : null}
          <div className="row">
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_text_eventify_fee}{" "}
            </label>
            <div className="col-md-3 text-right">{this.state.eventifyfee}</div>
          </div>
          <hr style={{ margin: 0 }} />
          <div className="row">
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_text_payment_getway_fee}{" "}
            </label>
            <div className="col-md-3 text-right">{this.state.stripefee}</div>
          </div>
          <hr style={{ margin: 0 }} />
          <div className="row">
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_text_client_pay}{" "}
            </label>
            <div className="col-md-3 text-right">{this.state.clientpay}</div>
          </div>
          <hr style={{ margin: 0 }} />
          <div className="row">
            <label className="col-md-9 text-left">
              {" "}
              {LocaleStrings.tickets_ticket_form_text_money_to_you}{" "}
            </label>
            <div className="col-md-3 text-right">{this.state.hostget}</div>
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  render() {
    var { selectedCurrency, isHideAmountInfoSection } = this.state;
    let categories = [
      { name: "Paid", value: "paid" },
      { name: "Free", value: "free" },
    ];
    let currencyDropList = [];
    var formsDropList = [];

    _.map(this.props.currencyList, (tindex) => {
      currencyDropList.push({ name: tindex.code, value: tindex.code });
    });

    _.map(this.props.totalFormBuildeList, (form) => {
      var name = form.formname + " (" + form.formnumber + ")";
      formsDropList.push({ name: name, value: form.formid });
    });

    let infoIconeStyle = {
      color: "#2676ea",
      fontSize: 15,
      paddingLeft: 10,
      paddingRight: 10,
    };
    let taxInfoIconeStyle = { color: "#2676ea", size: 30, paddingLeft: 10 };

    return (
      <div className="basicform">
        {/* <div className="row">
          <div className="col-md-12" style={{padding:0}}>
            <Field
              name="formid"
              label={LocaleStrings.tickets_ticket_form_label_checkout_name}
              // placeholder={LocaleStrings.tickets_ticket_form_ph_checkout_name}
              type="select"
              mandatory='true'
              component={this.renderSelect}
              opts={formsDropList}              
              labelposition={LABEL_POSITION_TOP}
              // disabled={this.props.editMode}
            />
          </div>        
        </div> */}

        <Field
          name="formid"
          type="text"
          component={this.renderHiddenFieldText}
          mandatory="true"
          value={formsDropList.length > 0 ? formsDropList[0].value : null}
        />

        <Field
          name="ticketname"
          label={LocaleStrings.tickets_ticket_form_label_ticket_name}
          placeholder={LocaleStrings.tickets_ticket_form_ph_ticket_name}
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          maxlength={MAXLENOBJ.ticketname ? MAXLENOBJ.ticketname : ""}
          // disabled={this.props.editMode}
        />
        {this.props.dateError.ticketnameerror !== "" ? (
          <div style={{ paddingLeft: 15 }}>
            <span style={{ color: "#d43f3a" }}>
              {this.props.dateError.ticketnameerror}
            </span>
          </div>
        ) : (
          ""
        )}

        <Field
          name="tickettype"
          label={LocaleStrings.tickets_ticket_form_label_ticket_type}
          // placeholder={LocaleStrings.tickets_ticket_form_ph_ticket_type}
          type="select"
          mandatory="true"
          component={this.renderSelect}
          opts={categories}
          onChange={this.changePriceTag}
          labelposition={LABEL_POSITION_TOP}
          // disabled={this.props.editMode}
        />

        {this.state.displayPrice ? (
          <div className="row">
            <label className="control-label-top col-sm-12">
              {LocaleStrings.tickets_ticket_form_label_ticket_price}
              <span className="label-mandatory">*</span>
            </label>

            <div className="col-md-6">
              <Field
                name="currency"
                placeholder={
                  LocaleStrings.tickets_ticket_form_ph_price_currency
                }
                type="select"
                component={this.renderSelect}
                opts={currencyDropList}
                onChange={this.handleCurrency}
                labelposition={LABEL_POSITION_TOP}
                // disabled={this.props.editMode}
              />
            </div>

            <div className="col-md-4">
              <Field
                name="price"
                placeholder={LocaleStrings.tickets_ticket_form_ph_price}
                type="number"
                min="1"
                component={this.renderFieldText}
                // disabled={this.props.editMode}
                onChange={this.priceCalc}
                parse={(val) => (val ? parseFloat(val, 2) : "")}
                labelposition={LABEL_POSITION_TOP}
              />
            </div>

            <div className="col-md-2 vcenter">
              + {LocaleStrings.tax}
              <OverlayTrigger
                trigger="click"
                placement="left"
                rootClose
                overlay={this.taxHtml()}
              >
                <i
                  className="fa fa-info-circle cursor-pointer"
                  style={taxInfoIconeStyle}
                ></i>
              </OverlayTrigger>
            </div>
          </div>
        ) : (
          ""
        )}

        {this.state.displayPrice && isHideAmountInfoSection == false ? (
          <div className="form-group row">
            <div className="col-md-6">
              <label className="control-label-top col-sm-12">
                {LocaleStrings.fee}
                <OverlayTrigger
                  trigger="click"
                  placement="left"
                  rootClose
                  overlay={this.feeHtml()}
                >
                  <i
                    className="fa fa-info-circle cursor-pointer"
                    style={infoIconeStyle}
                  ></i>
                </OverlayTrigger>
              </label>
            </div>

            <div className="col-md-6">
              <label className="control-label-top col-sm-12">
                {LocaleStrings.tickets_ticket_form_text_money_to_you}
              </label>
              <div className="col-md-12" style={{ fontSize: 25 }}>
                {selectedCurrency} {this.state.hostget}
                <OverlayTrigger
                  trigger="click"
                  placement="right"
                  rootClose
                  overlay={this.paymentDetailsHtml()}
                >
                  <i
                    className="fa fa-info-circle cursor-pointer"
                    style={infoIconeStyle}
                  ></i>
                </OverlayTrigger>
              </div>
            </div>
          </div>
        ) : null}

        <Field
          name="isaccessall"
          label={LocaleStrings.tickets_ticket_form_label_allow_all_access}
          type="checkbox"
          mandatory="true"
          component={this.renderFieldCheckbox}
        />

        <Field
          name="plandays"
          label={LocaleStrings.tickets_ticket_form_label_plandays}
          placeholder={LocaleStrings.tickets_ticket_form_ph_plandays}
          type="number"
          component={this.renderFieldText}
          mandatory="true"
          // disabled={this.props.editMode}
        />
        {this.props.dateError.ticketnameerror !== "" ? (
          <div style={{ paddingLeft: 15 }}>
            <span style={{ color: "#d43f3a" }}>
              {this.props.dateError.ticketnameerror}
            </span>
          </div>
        ) : (
          ""
        )}

        <Field
          name="ticketdesc"
          label={LocaleStrings.tickets_ticket_form_label_ticket_description}
          placeholder={LocaleStrings.tickets_ticket_form_ph_ticket_description}
          component={this.renderFieldTextarea}
          mandatory="true"
          maxlength={MAXLENOBJ.ticketdesc ? MAXLENOBJ.ticketdesc : ""}
          labelposition={LABEL_POSITION_TOP}
          // disabled={this.props.editMode}
        />

        <div className="row">
          <label className="control-label-top col-sm-12">
            {LocaleStrings.tickets_ticket_form_label_ticket_status}
            <span className="label-mandatory">*</span>
          </label>

          <div className="col-md-12 d-flex">
            <Field
              name="status"
              label={
                LocaleStrings.tickets_ticket_form_label_ticket_status_option1
              }
              component={this.renderFieldRadio}
              type="radio"
              value="enabled"
            />{" "}
            <Field
              name="status"
              label={
                LocaleStrings.tickets_ticket_form_label_ticket_status_option2
              }
              component={this.renderFieldRadio}
              type="radio"
              value="disabled"
            />{" "}
            <Field
              name="status"
              label={
                LocaleStrings.tickets_ticket_form_label_ticket_status_option3
              }
              component={this.renderFieldRadio}
              type="radio"
              value="hidden"
            />
          </div>

          <div className="col-md-12">
            <Field
              name="statuserror"
              component={this.renderHiddenFieldText}
              type="input"
            />
          </div>
        </div>
      </div>
    );
  }
}
